"use client";

import { useEffect, useState } from "react";
import StatsCard, { StatVariant } from "@/app/(components)/generics/StatsCard/StatsCard";
import { getAdminUsersStats } from "@/app/actions/admin/action";
import { TKey } from "@/app/translations/TKey";
import { T } from "@/app/translations/Translations";
import { UsersStats } from "@/app/types/payload/response/UsersStats";
import { Routes } from "@/app/vars/Routes";

type Props = { lang: string };

export default function UsersOverview({ lang }: Props) {
  const [stats, setStats] = useState<UsersStats>({
    total: 0,
    active: 0,
    emailPending: 0,
    invitePending: 0,
    noInvite: 0,
  });

  useEffect(() => {
    getAdminUsersStats().then((data) => {
      if (data) setStats(data);
    });
  }, []);

  return (
    <StatsCard
      title={T(TKey.USERS, lang) as string}
      link={{ href: Routes.PROTECTED.ADMIN.USERS(lang), label: T(TKey.MANAGE, lang) as string }}
      stats={[
        { value: stats.total, label: T(TKey.OVERVIEW_TOTAL, lang) as string },
        {
          value: stats.active,
          label: T(TKey.USER_ACTIVE, lang) as string,
          variant: StatVariant.ACTIVE,
        },
        {
          value: stats.emailPending,
          label: T(TKey.USER_EMAIL_PENDING, lang) as string,
          variant: StatVariant.PENDING,
          hidden: stats.emailPending === 0,
        },
        {
          value: stats.invitePending,
          label: T(TKey.USER_PENDING, lang) as string,
          variant: StatVariant.PENDING,
          hidden: stats.invitePending === 0,
        },
        {
          value: stats.noInvite,
          label: T(TKey.USER_NO_INVITE_SENT, lang) as string,
          variant: StatVariant.MUTED,
          hidden: stats.noInvite === 0,
        },
      ]}
    />
  );
}
